<header class="container-fluid p-3">
  <div class="d-flex justify-content-between">
    <h3><ng-content></ng-content></h3>
  </div>
</header>
